import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const LogoWhite = ({className}) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "logo-white@2x.png" }) {
          childImageSharp {
            fixed(width: 134, height: 50, quality: 100) {
              ...GatsbyImageSharpFixed_tracedSVG
            }
          }
        }
      }
    `}
    render={data => <Img fadeIn={false} className={className} critical={true} fixed={data.file.childImageSharp.fixed} />}
  />
)
export default LogoWhite
